import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { CarTypeSelector } from './selectors/CarTypeSelector';
import { OpenfoamVersionSelector } from './selectors/OpenfoamVersionSelector';
import { CFDModelSelector } from './selectors/CFDModelSelector';
import { VelocitySelector } from './selectors/VelocitySelector';
import { CommentField } from './selectors/CommentField';

interface Props {
  subtitle: string;
}

export const CFDForm: React.FC<Props> = ({ subtitle }) => {
  return (
    <Accordion sx={{ backgroundColor: '#404040', color: '#333' }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="cfd-content"
        id="cfd-header"
      >
        <CustomTypography >{subtitle}</CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="div">
          <CarTypeSelector label={"Car Type"} />
        </Box>
        <Box component="div">
          <OpenfoamVersionSelector label={"OpenFoam Version"} />
        </Box>
        <Box component="div">
          <CFDModelSelector label={"CFD Model"} />
        </Box>
        <Box component="div">
          <VelocitySelector label={"Velocity"} />
        </Box>
        <Box component="div">
          <CommentField label={"Comment"} />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
